<div [innerHtml]="html | gbSafe: safeType" class="quill-html"></div>
